module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "ui celled table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Name')) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.customer.firstname) + " " + _vm._s(_vm.customer.lastname) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('Email')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.customer.email))])])])]), _vm._v(" "), _c('address-modal', [_c('button', {
    staticClass: "ui blue button mb-2",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v(_vm._s(_vm.$t('Add a new address')) + "\n    ")])]), _vm._v(" "), (_vm.customer.addresses.length > 0) ? _c('div', {
    staticClass: "addresses-content"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_c('tbody', _vm._l((_vm.customer.addresses), function(address, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', [_c('strong', [_vm._v(_vm._s(address.alias))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(address.firstname) + " " + _vm._s(address.lastname))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(address.address1) + " " + _vm._s(address.address2))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(address.postcode) + " " + _vm._s(address.city))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getCountryNameFromId(address.id_country)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('Phone')) + ": " + _vm._s(address.phone))]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.$t('Phone (Mobile)')) + ": " + _vm._s(address.phone_mobile) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "150px"
      }
    }, [_c('address-modal', {
      attrs: {
        "mode": "edit",
        "address_to_edit": _vm.customer.addresses[index]
      },
      on: {
        "input": function($event) {
          return _vm.updateEditedAddress($event, index)
        }
      }
    }, [_c('button', {
      staticClass: "ui icon button purple right aligned",
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('i', {
      staticClass: "icon edit"
    })])]), _vm._v(" "), _c('button', {
      staticClass: "ui icon button red right aligned",
      on: {
        "click": function($event) {
          return _vm.askDeleteAddress(address)
        }
      }
    }, [_c('i', {
      staticClass: "icon trash"
    })])], 1)])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "index": _vm.address_to_delete,
      "icon": "delete",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to delete this address ?"
    },
    on: {
      "cancel": function($event) {
        _vm.address_to_delete = null
      },
      "delete": _vm.deleteAddress
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657bb48c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/AddressTab.vue
// module id = 503
// module chunks = 1